import { makePostRequest } from 'lib/axios';

export interface BagelChatUploadedImage {
  assetId: string;
  url?: string;
  thumbnailUrl?: string;
  width?: number;
  height?: number;
}

/**
 * Upload a real image attached in the Bagel chat widget. Returns a permanent public URL the
 * model can reference verbatim in code, instead of inventing content when asked to reuse an
 * existing image (e.g. a favicon or a staff photo).
 */
export async function uploadBagelChatImage(
  file: File,
): Promise<BagelChatUploadedImage> {
  const formData = new FormData();
  formData.append('file', file);

  const res = await makePostRequest<{
    message: string;
    payload: BagelChatUploadedImage;
  }>('/bagel/chat/upload-image', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data.payload;
}
